import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';


const MobilePage = (props) => {

  return (
    <Container fluid={true} className="mt-5">
      <Container className="">
        <Row className="h-100">
          <Col className="d-flex flex-column justify-content-center">
            <h1 className="fw-bold fs-1">{props.title}</h1>
            <p className="fw-lighter fs-4 mt-3">{props.subtitle}</p>
            <p className="fw-lighter fs-4">{props.subsubtitle}</p>
            <p className="fw-lighter fs-4 mt-2">PRMAssist makes it simple.</p>
          </Col>
        </Row>
        <Row>
          {props.image}
        </Row>
      </Container>
    </Container>
  );
}


export default MobilePage;